import React, { useMemo, useState } from 'react'

import i18n from 'i18n-literally'

import { Autocomplete, Box, TextField } from '@mui/material'

import {
  Field,
  Form,
  Formik,
  useFormikContext,
} from 'formik'

import createLogger from '~/src/Lib/Logging'
import Button from '~/src/UI/Shared/Button'
import { FormikTextField } from '~/src/UI/Shared/Form/TextField'
import TimezoneAutocomplete from '~/src/UI/Shared/Timezone/TimezoneAutocomplete'
import T from '~/src/UI/Shared/Typography'

import {
  getFacilityInfoInitialValues,
  getFacilityInfoValidationSchema,
  getStateProvidenceOpts,
} from './utils'

const displayName = 'FacilityInfoForm'
const logger = createLogger(displayName)

const FacilityInfo = ({
  handleGoBackStep,
  handleNextStep,
  options
}) => {
  const [timezone, setTimezone] = useState('')
  const [providence, setProvidence] = useState('')
  const { isValid, setFieldValue } = useFormikContext()

  return (
    <Form>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="1rem"
      >
        <T.H2>{i18n`Your AROYA GO Facility`}</T.H2>
        <T>{i18n`Define a home for your data`}</T>
        <Box width={300} display="flex" flexDirection="column" gap="3rem">
          <Box display="flex" flexDirection="column" gap="1ch">
            <Field
              fullWidth
              required
              name="name"
              label={i18n`Facility/Grow name`}
              component={FormikTextField}
            />
            <Autocomplete
              name="state"
              sx={{
                '& [class*=MuiFilledInput-input]': {
                  position: 'relative'
                }
              }}
              value={providence}
              options={options}
              onChange={(event, { value, label }) => {
                setFieldValue('state', value)
                setProvidence(label)
              }}
              renderInput={params => <TextField {...params} required label={i18n`State/Providence`} />}
            />
            <TimezoneAutocomplete
              inputValue={timezone}
              setInputValue={setTimezone}
            />
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Button
              variant="text"
              onClick={handleGoBackStep}
            >
              {i18n`Go back`}
            </Button>
            <Button
              disabled={!isValid}
              sx={{ padding: '0 3rem' }}
              onClick={handleNextStep}
            >
              {i18n`Next`}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

const Connected = props => {
  const initialValues = getFacilityInfoInitialValues()
  const validationSchema = getFacilityInfoValidationSchema()
  const options = useMemo(() => getStateProvidenceOpts(), [])
  const handleSubmit = () => {}

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FacilityInfo
        options={options}
        {...props}
      />
    </Formik>
  )
}

const Memoized = React.memo(Connected)
export default Memoized
